const checkoutReturnUrl = ref<string>('');

export function useCheckoutReturnUrl() {
  const setCheckoutReturnUrl = (url: string): void => {
    checkoutReturnUrl.value = url;
  };

  const resolveReturnUrl = (): string =>
    checkoutReturnUrl.value || (import.meta.client ? globalThis.location.href : '');

  return { checkoutReturnUrl, setCheckoutReturnUrl, resolveReturnUrl };
}
